import { render } from "./CertificationsListPage.vue?vue&type=template&id=76824484&scoped=true&ts=true"
import script from "./CertificationsListPage.vue?vue&type=script&lang=ts"
export * from "./CertificationsListPage.vue?vue&type=script&lang=ts"

import "./CertificationsListPage.vue?vue&type=style&index=0&id=76824484&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76824484"]])

export default __exports__